module.exports = __webpack_public_path__ + "static/android-chrome-192x192-23d89e2bce23ad7f5bc983d494f6211c.png";